import React from "react";
import { Link } from "react-router-dom";

const styles = {
  height: "100vh",
  width: "100%",
};

const PageNotFound = () => {
  return (
    <div
      className=" image404 text-center container-fluid my-5 p-2 "
      style={styles}
    >
      <h5 className="text-warning my-3">
        <span className="text-danger">OOPS!</span> The link is broken or the
        page has been removed.
      </h5>
      <h6 className="text-warning">Try these links instead:</h6>
      <a href="/services" className="btn btn-outline-primary m-1">
        Services
      </a>
      <a href="/careers" className="btn btn-outline-primary m-1">
        Careers
      </a>
      {/* <a href="/contact" className="btn btn-outline-primary m-1">
        Contact Us
      </a> */}
      <a href="/about" className="btn btn-outline-primary m-1">
        About Us
      </a>
    </div>
  );
};

export default PageNotFound;
